<div
  class="zone"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
>
  <div id="dropZ">
    <i class="fa fa-cloud-upload"></i>
    <div>Drag and drop your file here</div>
    <span>OR</span>
    <div class="button-row">
      <button
        class="btn btn-light hover-button mail"
        (click)="fileInput.click()"
      >
        Select File
      </button>
      <!-- <button
        class="btn btn-light hover-button mail"
        [disabled]="!isSubmitEnabled"
        (click)="submitClick()"
      >
        Submit
      </button> -->
    </div>
  </div>
  <input
    type="file"
    hidden
    #fileInput
    (change)="onFileSelected($event)"
   
    accept=".xlsx, .xls, .xlsm, .csv"
  />
</div>